'use strict';

const Backbone = require('backbone/backbone');
const _ = require('underscore/underscore');

require('./Page.less');

module.exports = Backbone.View.extend({

    el: 'body',

    events: {},

    initialize: function (options = {}) {
        _.extend(this, options);

        this.onResize = this.onResize.bind(this);
        this.onScroll = this.onScroll.bind(this);

        this.scrollItems = [];

        $('[data-scroll]').each(function (ind, item) {
            this.scrollItems.push({
                el: item,
                $el: $(item),
                offset: ($(item).attr('data-scroll-offset') - 0) * (!app.settings.isPhone ? 2 : 1),
                screenPosition: -1,
                listeners: {
                    'screen-position': [],
                    'screen-bottom': [],
                    'screen-enter': [],
                    'screen-leave': []
                }
            });

            //we will use custom trigger/on/off realization
            //cause jquery version (the one using dom) is too slow
            $(item).data('listeners', this.scrollItems[this.scrollItems.length - 1].listeners);
        }.bind(this));

        var prevWw = window.innerWidth;
        var onResizeThrottled = _.throttle(this.onResize, 16.6666666 * 8, {leading: false});

        $(window)
            .on('resize', function () {
                var curWw = window.innerWidth;
                this.windowHeight = window.innerHeight;

                this.calcStickyGalleries();

                if (curWw !== prevWw) {
                    onResizeThrottled();
                }

                prevWw = curWw;
            }.bind(this));

        window.addEventListener('scroll', this.onScroll);

        //proceed resize and scroll with throttle
        onResizeThrottled();

        this.calcStickyGalleries();

        setTimeout(function () {
            this.$('source.delayed').each(function () {
                var srcset = this.getAttribute('data-srcset');
                var sizes = this.getAttribute('data-sizes');
                srcset && this.setAttribute('srcset', srcset);
                sizes && this.setAttribute('sizes', sizes);
            });

            this.$('img.delayed').each(function () {
                var src = this.getAttribute('data-src');
                src && this.setAttribute('src', src);
            });
        }, 2000);

        app.vent.on('page-height-changed', this.onResize);
    },


    calcStickyGalleries: function () {
        this.$('.section-columns').each(function (ind, item) {
            var $firstColumn = $(item).find('.section-column')
                .eq(0);
            var $secondColumn = $(item).find('.section-column')
                .eq(1);

            $firstColumn.css('min-height', $secondColumn.height());
        });
    },

    updateItemsPos: function () {
        this.scrollItems.forEach(function (item) {
            item.height = item.$el.height();
            item.top = item.$el.offset().top;
        }.bind(this));
    },


    onResize: function () {
        this.hasItemsPoses = true;
        this.updateItemsPos();
        this.windowHeight = window.innerHeight;
        this.onScroll();
        // $(window).scrollTop(9999);
    },


    onScroll: function () {
        if (!this.hasItemsPoses) {
            return;
        }

        var scrollTop = window.pageYOffset;
        var self = this;
        var wh = self.windowHeight;

        var triggerEvent = function (item, eventName, options) {
            var listeners = item.listeners[eventName];
            for (var i = 0 ; i < listeners.length; i++) {
                listeners[i]({}, options);
            }
        };

        self.scrollItems.forEach(function (item) {
            var screenPosition = (scrollTop - (item.top - wh + item.offset)) / (item.height + wh - item.offset);
            var screenPositionConstrained = Math.min(Math.max(screenPosition , 0), 1);
            var screenBottom = scrollTop + wh - (item.top + item.height);

            if (item.screenPositionConstrained !== screenPositionConstrained) {
                triggerEvent(item, 'screen-position', {
                    $el: item.$el,
                    screenPosition: screenPositionConstrained,
                    height: item.height
                });
                item.screenPositionConstrained = screenPositionConstrained;
            }

            triggerEvent(item, 'screen-bottom', {
                $el: item.$el,
                screenBottom: screenBottom,
                height: item.height
            });

            if ((item.screenPosition < 0 && screenPosition >= 0) || (item.screenPosition > 1 && screenPosition <= 1)) {
                if (item['data-scroll-state'] !== 'enter') {
                    triggerEvent(item, 'screen-enter', {
                        $el: item.$el
                    });

                    if (!item.shown) {
                        item.el.setAttribute('data-show-animation-state', 1);
                        item.shown = true;
                    }

                    item['data-scroll-state'] = 'enter';
                }
            }

            if ((item.screenPosition >= 0 && screenPosition < 0) || (item.screenPosition <= 1 && screenPosition > 1)) {
                if (item['data-scroll-state'] !== 'leave') {
                    triggerEvent(item, 'screen-leave', {
                        $el: item.$el
                    });

                    item['data-scroll-state'] = 'leave';
                }
            }

            item.screenPosition = screenPosition;
        });
    },


    _initChildViews(views) {
        if (!this.childViews) {
            this.childViews = {};
        }
        for (let i = 0; i < views.length; i++) {
            this.childViews[views[i].name] = new views[i].Constructor({page: this});
        }
    }
});
